// extracted by mini-css-extract-plugin
module.exports = {"product_mock":"A0_product_mock__1DkYQ","prototype_new":"A0_prototype_new__EnyTz","top_container":"A0_top_container__1EfPM","container":"A0_container__2s3S0"};